const checkboxContainer = {
  display: 'grid',
  gridTemplateColumns: '1fr 1.2fr',
  gridColumnGap: 24,
}

export default { checkboxContainer }
